<template>
  <div class="cwsf-parent-container">
    <div class="cwsf-container">
        <span class="handle-checkboxes">
          <checkbox ref="cwsfExperienceCheckbox" @input="(value) => handleSelection('cwsfUser', value)" :disabled="userRole" :label="$t('signup-modal.cwsf.step1.option1.1')" id="cwsfUser" name="cwsfUser" value="isCwsfUser"/>
        </span>
        <div class="cwsfExpeienceNotesTitle">
          <div class="cwsfTitle">{{ $t("signup-modal.cwsf.step1.option1.2")}}</div>
          <ul class="cwsfExperienceNotes">
            <li>{{ $t("signup-modal.cwsf.step1.option1.3")}}</li>
            <li>{{ $t("signup-modal.cwsf.step1.option1.4")}}</li>
            <li>{{ $t("signup-modal.cwsf.step1.option1.5")}}</li>
          </ul>
        </div>
        <span class="handle-checkboxes">
        <checkbox ref="cwsfViewerCheckbox" @input="(value) => handleSelection('cwsfViewer', value)" :disabled="userRole" :label="$t('signup-modal.cwsf.step1.option2')" id="cwsfViewer" name="cwsfViewer" value="isCwsfViewer"/>
        </span>
    </div>
    <div class="cwsfLandingCheckboxError">
      <div v-if="cwsfLandingCheckboxError">
        {{ $t('signup-modal.cwsf.selectOption') }}
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Controls/Checkbox'
import Input from '@/components/Controls/Input'
export default {
  name: 'YscStepOne',
  components: {
    Checkbox,
    Input
  },
  props: ['label', 'error', 'qaClass', 'userRole'],
  data: function () {
    return {
      cwsfLandingCheckboxError: false
    }
  },
  methods: {
    handleSelection: function (option, value) {
      if (option === 'cwsfUser' && value) {
        this.$refs.cwsfViewerCheckbox.checked = false
        this.userRole.cwsfViewer = false
        this.userRole.cwsfUser = value
      }
      if (option === 'cwsfViewer' && value) {
        this.$refs.cwsfExperienceCheckbox.checked = false
        this.userRole.cwsfViewer = value
        this.userRole.cwsfUser = false
      }

      this.$emit('childToParent', this.userRole)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $modal-body-color: #F2F2F2;
  $modal-footer-color: #F7F7F7;
  $close-icon-color: #1A051D;
  $border-color: #DCDCDC;
  $placeholder-font-color: #565656;
  $input-background-color: #FFFFFF;
  $input-height: 40px;
  $bottom-message-font-color: #3F3F3F;

  .numStudents {
    width: 3.5rem;
    font-size: 1rem;
  }

  .left {
    text-align: left;
  }
  .occupation {
    margin-left: 15%;
  }
  .isef-spacing {
    margin-bottom: 1.5rem;
  }

  .modal {
    z-index: 50;
  }

  .modal-card {
    background: $modal-body-color;
    padding: 1.3rem 0 0;
    text-align: center;
    overflow: auto;
    @include mobile {
      max-width: 98vw;
    }
  }

  .close {
    top: 0.4rem;
    right: 1rem;
    position: absolute;
    font-size: 1.5rem;
    color:  $close-icon-color;
    border: none;
    padding: 0;
    background: transparent;
    &:hover {
      color: $link-hover;
    }
  }

  .make-login {
    margin: 0.7rem 0 0.4rem;
    text-align: center;
  }

  .apple-login {
    margin: 0.7rem 0 0.4rem;
    text-align: center;
  }

  .section {
    height: auto;
    padding: 0;

    .container {
      margin: auto;
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center;
      width: 500px;
      @include mobile {
        width: 300px;
        max-width: 300px;
      }
      @media screen and (max-height: 375px) {
        margin-top: auto;
      }
    }
  }

  .title {
    font-family: $primary-font;
    font-weight: $primary-font-weight;
    @include mobile{
      font-size: 1.75rem;
    }
  }

  .subtitle {
    width: inherit;
    color: #4A4A4A;
    margin: 0;
    padding: 1.5rem 0;
    font-size: 0.9rem;
    line-height: 1.4rem;
  }

  .full-width {
    width: 100%;
  }

  .button {
    border-radius: 0;
    padding: 1rem 1.5rem;
    text-transform: uppercase;
    font-size: 0.9rem;
    &.continue-button {
      margin: 1.1rem 0 1.1rem;
      padding: 1.15rem 1.2rem;
    }
    &.using-password-button {
      margin: 0 0 1.5rem;
    }
  }
  .button[disabled] {
    pointer-events: none;
  }

  .is-apple {
    background-color: transparent;
    border-color: transparent;
    color: black;
  }

  // Google, Facebook, and Mobile Buttons
  .third-party-buttons {
    width: 100%;
    padding-bottom: 1rem;
    justify-content: center;
    .button {
      padding: 0;
      width: 2.5rem;
      height: 2.5rem;
      text-transform: capitalize;
      .icon {
        font-size: 1.3rem;
      }
      .make-icon {
        height: 2.5rem;
        width: 2.5rem;
        img {
          width: 100%;
        }
      }
      .apple-icon {
        height: 2.5rem;
        width: 2.5rem;
        img {
          width: 100%;
        }
      }
      .fa-facebook-f {
        font-size: 1.4rem;
      }
      .fa-phone {
        margin-bottom: 1px;
      }
    }
  }

  .lower {
    padding-bottom: 3rem;
    font-size: .75rem;
  }

  .links {
    display:flex;
    @include mobile{
      font-size: 0.8rem;
    }
  }

  .tip {
    cursor: pointer;
    @include mobile {
      display: none;
    }
  }

   .occupationError {
     margin-top: 0.5rem;
     color: red;
     height: 2rem;
  }

  .cwsfLandingCheckboxError {
     margin-top: 1rem;
     color: red;
     height: 2rem;
  }

  .notSelectedError {
     color: red;
     height: 2rem;
  }

  .error {
    text-align: center;
  }

  .help.error {
    color: #EA002A;
  }

  .password-check {
    list-style-type: none;
    padding-left: 0.8rem;
    color: #FF3860;

    li:before {
      content: "\2715";
      padding-right: 0.5rem;
    }

    li.success {
      color: green;
    }

    li.success:before {
        content: "\2713";
        padding-right: 0.5rem;
      }
  }

  .try-again-container{
    display: flex;
    flex-direction: column;
    width: 100%;
    .student-email-message {
      padding-top: 2rem;
    }
  }

  .login-link-button {
    align-items: center;
    span {
      margin-left: 0.3rem;
    }
  }

  .welcome-modal {
    border-bottom: 1px solid $border-color;
    padding-bottom: 1.3rem;
  }

  .signup {
    margin-top: 0.5rem;
  }
  .control {
    &.make-projects {
      margin: 2.4rem 0 1.4rem;
    }
  }

  .other-login-button {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    border-radius: 50%;
    justify-content: center;
    .make-icon {
      height: 2.5rem;
      width: 2.5rem;
    }
    &:hover {
      background-color: $link-hover;
    }
    .make {
      &:hover {
        background-color: transparent !important;
      }
      .icon {
        height: 2rem;
        width: 2rem
      }
    }
    .apple {
      &:hover {
        background-color: transparent !important;
      }
      .icon {
        height: 2rem;
        width: 2rem
      }
    }
  }
  .make {
    &:hover {
      background-color: transparent;
    }
  }
  .apple {
    &:hover {
      background-color: transparent;
    }
  }

  .terms-of-service {
    font-family: 'Roboto';
    font-weight: 300;
    font-size: 0.9rem;
    padding: 0.3rem 0 0.5rem;
    a {
      color: #373737;
      text-decoration: underline;
      &:hover {
        color: $link-hover;
      }
      @include mobile {
        display: block;
      }
    }
  }

  .code-of-conduct {
    a {
      color: #373737 !important;
      text-decoration: underline !important;
    }
  }

  .next-button-container {
    margin: 0.5rem 0 0;
    width: 100%;
    background-color: $modal-footer-color;
    @include mobile {
      margin: 0;
    }
  }

  .writeup {
    font-size: 0.9rem;
    padding:1.7rem 0 2.1rem;
    width: inherit;
    font-family: $primary-font;
  }

  .has-account-message {
    color: $bottom-message-font-color;
    font-weight: 600;
  }

  .pre-formatted {
    white-space: pre;
  }

  .signup-inputs {
    padding-bottom: 1rem;
    width: inherit;
    input[type=search] {
      padding-left: 20px;
    }
    input[type=password] {
      &::-webkit-credentials-auto-fill-button {
        width: 0px;
        height: 0px;
        margin: 0;
        display: none !important; // This should work, but because of the way the webkit auto fill button is designed, its own important overwrites this.
      }
    }
    @include mobile {
      padding-bottom: 1rem;
    }
  }

  .welcome-modal.title {
    font-size: 1.5rem;
    margin-bottom: 0;
  }

  input[placeholder] {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .checks {
    padding-top: 5px;
  }

  .redirect-message {
    top: 0px;
    position: relative;
    padding-bottom: 1rem;
  }

  .ysc-questions {
    padding-bottom: 9px;
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    font-size: 16px !important;
  }

  .signup-reason {
    color: $bottom-message-font-color;
    font-weight: 500;
    margin-top: -10px;
    font-size: 1.07rem;
  }

  #student-checkbox, #visitor-checkbox {
    left: 70px;
    height: 0px;
  }
  .handle-checkboxes {
    display: flex;
    width: 100%;
    font-size:1.06rem
  }
  .weight-spacing {
    margin-left: 4rem;
    font-weight: 400;
  }

  .cwsfExpeienceNotesTitle {
    text-align: left;
    padding-left: 1rem;
  }

  ul.cwsfExperienceNotes {
    padding-left: 20%;
    list-style: disc;
    text-align: left;
  }
  .cwsf-parent-container {
    width: 100%;
    display: flex;
    justify-content: center;
    ::v-deep .checkboxes {
      width: 100% !important;
    }
  }
  .cwsf-container {
    width: 100%;
    .handle-checkboxes {
      margin-bottom: 1rem;
    }
    .cwsfExperienceNotes li{
      margin-bottom: 0.10rem;
      margin-top: 0.10rem;
    }
    .cwsfExperienceNotes{
      display: flex;
      justify-content: center;
      flex-direction: column;
      list-style-position: inside;
    }
    .cwsfTitle{
      margin-bottom: 0.5rem;
      font-weight: bold;
    }
  }

</style>
<style lang="scss">
  body.ios-modal-fix {
    position: fixed;
  }
</style>
